export default "__VITE_ASSET__b69ad73d__"